import styled from 'styled-components';

import { COLORS } from './constants';

export const Wrapper = styled.div`
  margin-top: 14px;

  .mso-rotate-up {
    transform: rotate(-90deg);
  }

  .mso-rotate-down {
    transform: rotate(90deg);
  }

  .mso-heading {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    margin-bottom: 8px;
  }

  .mso-heading-title {
    font-size: 13px;
    font-weight: 700;
    color: ${COLORS.text};
    letter-spacing: 0.02em;
    text-transform: uppercase;
  }

  .mso-heading-hint {
    font-size: 11px;
    color: ${COLORS.faint};
  }

  .mso-row {
    border: 1px solid ${COLORS.border};
    border-radius: 8px;
    background: ${COLORS.surface};
    padding: 10px;
    transition: border-color 0.15s ease;
  }

  .mso-row:not(.is-open):hover {
    border-color: ${COLORS.accent};
  }

  .mso-row + .mso-row {
    margin-top: 10px;
  }

  .mso-row-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }

  .mso-row.is-open .mso-row-head {
    margin-bottom: 6px;
  }

  .mso-row-toggle {
    display: flex !important;
    align-items: center;
    gap: 8px;
    flex: 1;
    min-width: 0;
    min-height: 26px;
    padding: 0;
    border: none;
    background: transparent;
    text-align: left;
    cursor: pointer;
  }

  .mso-row-chevron {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    margin-right: 4px;
    border-radius: 4px;
    background: ${COLORS.hoverBg};
    color: ${COLORS.text};
    transform-origin: center;
    transition: transform 0.15s ease, background-color 0.15s ease;
  }

  .mso-row-toggle:hover .mso-row-chevron {
    background: ${COLORS.accentSoft};
    color: ${COLORS.accent};
  }

  .mso-row-chevron.is-open {
    transform: rotate(90deg);
  }

  .mso-row-index {
    flex-shrink: 0;
    font-size: 11px;
    font-weight: 600;
    color: ${COLORS.faint};
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }

  .mso-row-preview {
    overflow: hidden;
    padding: 2px 0 2px 10px;
    margin-left: 2px;
    border-left: 1px solid ${COLORS.border};
    font-size: 12px;
    line-height: 1.5;
    color: ${COLORS.text};
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .mso-row-preview p {
    display: inline;
    margin: 0;
  }

  .mso-row-preview-empty {
    color: ${COLORS.faint};
    font-style: italic;
  }

  .mso-row-actions {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    gap: 6px;
  }

  .mso-field-label {
    display: block;
    margin: 8px 0 4px;
    font-size: 11px;
    font-weight: 600;
    color: ${COLORS.faint};
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }

  .mso-icon-input {
    width: 96px;
  }

  .mso-check {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 10px 0 0;
    font-size: 12px;
    font-weight: 500;
    color: ${COLORS.text};
    cursor: pointer;
  }

  .mso-check input {
    margin: 0;
    accent-color: ${COLORS.accent};
  }

  .mso-image-field {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .mso-image-thumb {
    flex-shrink: 0;
    width: 34px;
    height: 34px;
    border: 1px solid ${COLORS.border};
    border-radius: 6px;
    object-fit: cover;
  }

  .mso-editor-shell {
    position: relative;
    border-radius: 4px;
  }

  .mso-editor-shell .rdw-editor-toolbar {
    display: flex;
    flex-wrap: wrap;
    row-gap: 2px;
    margin: 0;
    padding: 3px 4px;
    border: none;
    border-bottom: 1px solid ${COLORS.border};
    border-radius: 3px 3px 0 0;
    background: ${COLORS.toolbarBg};
  }

  .mso-editor-shell .rdw-option-wrapper {
    min-width: 22px;
    height: 22px;
    margin: 0 2px;
    border-color: transparent;
    background: transparent;
  }

  .mso-editor-shell .rdw-option-wrapper:hover,
  .mso-editor-shell .rdw-option-active {
    box-shadow: none;
    background: ${COLORS.hoverBg};
    border-color: ${COLORS.border};
  }

  .mso-editor-shell .rdw-colorpicker-modal,
  .mso-editor-shell .rdw-link-modal {
    z-index: 30;
    left: 0;
    width: 210px;
    height: auto;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
  }

  .mso-editor-shell .rdw-colorpicker-modal-options {
    overflow-y: auto;
  }

  .mso-editor-shell .rdw-link-modal-input,
  .mso-editor-shell .rdw-link-modal-target-option {
    font-size: 12px;
  }

  .mso-editor-shell .rdw-editor-main {
    min-height: 38px;
    max-height: 120px;
    padding: 2px 8px;
    overflow-y: auto;
    font-size: 13px;
  }

  .mso-editor-shell .public-DraftStyleDefault-block {
    margin: 4px 0;
  }
`;

export const RemoveOptionButton = styled.button`
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  padding: 0;
  border: 1px solid ${COLORS.border} !important;
  border-radius: 6px;
  background: ${COLORS.surface};
  color: ${COLORS.danger};
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease,
    color 0.15s ease;

  &:hover {
    background: ${COLORS.hoverBg};
    border-color: ${COLORS.dangerHover} !important;
    color: ${COLORS.dangerHover};
  }
`;

export const MoveOptionButton = styled.button`
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  padding: 0;
  border: 1px solid ${COLORS.border} !important;
  border-radius: 6px;
  background: ${COLORS.surface};
  color: ${COLORS.faint};
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease,
    color 0.15s ease;

  &:hover:not(:disabled) {
    background: ${COLORS.hoverBg};
    color: ${COLORS.text};
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const ValueInput = styled.input`
  width: 100%;
  padding: 7px 10px;
  border: 1px solid ${COLORS.border};
  border-radius: 6px;
  font-size: 13px;
  color: ${COLORS.text};
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: ${COLORS.accent};
  }
`;

export const AddOptionButton = styled.button`
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
  padding: 7px 14px;
  border: 1px dashed ${COLORS.accent} !important;
  border-radius: 6px;
  background: ${COLORS.surface};
  color: ${COLORS.accent};
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;

  &:hover {
    background: ${COLORS.accentSoft};
  }
`;
